export default __webpack_public_path__ + "static/media/public-offer.171dc717.pdf";